(function() {

	'use strict';

	angular.module('app').controller('ClientCompanyOnboardingController',
		function($scope, Units, ClientService, $routeParams, $location) {
			$scope.params = $routeParams || {};
			$scope.unitsList = Units;
			$scope.companyLocation = false;
			$scope.toggleChanged = toggleChanged;
			$scope.goTo = goTo;
			$scope.company = {
				measureUnit: Units.measureUnit[0]['short'],
				weightUnit: Units.weightUnit[0]['short'],
				active: false,
				notify: true
			};
			$scope.companyId = $scope.params.companyId || false;

			if ($scope.companyId) {
				ClientService.Company.get($scope.companyId, function(data) {
					$scope.companyLocation = data.location;
					$scope.company = data;
				});
			}

			function toggleChanged(viewMode) {
				//console.log(viewMode)
			}

			$scope.createClient = function() {
				var requestData = {};
				// Client.createClient(requestData, function() {
				// 	console.log(arguments);
				// }, function() {
				// 	console.log(arguments);
				// }, $scope.companyId);
			};

			function cancel() {
				$location.path('/client');
			}

			function goTo(path, params) {
				$location.path(path).search(params);
			}
		});
})();



// WEBPACK FOOTER //
// ./js/controllers/client/ClientCompanyOnboardingController.js